import React from "react";
import style from "./index.module.scss";
// import styled from "?styled-components";

const App = props => {
  let { title, subtitle, bg, getData } = props
  return (
    <div className={style.prodContainer}>
      <div className={`${style.prodContent}`}>
        <div className={`${style.title}`}><i></i>{title}<i></i></div>
        <div className={`${style.subtitle}`}>{subtitle}</div>
        <div className={`${style.list}`}>
          {
            getData.data &&
            getData.data.data.map((item) => (
              <div  key={item.title} className={`${style.listItemWrapper}`}>
                <div className={`${style.listItem}`} key={item.link}>
                  <div><img src={item.link} alt=""/></div>
                  <p>{item.title}</p>
                </div>
              </div>
            ))
          }
        </div>
      </div>
      <div className={`${style.bgImage}`} style={{"background": `url(${bg}) no-repeat`,"backgroundSize":"cover"}}></div>
    </div>
  );
};

export default App;
